<template>
    <div id="app">
        <router-view/>
        
    </div>
</template>

<script>

    export default {
        name: 'app',
        mounted() {
            document.oncontextmenu = function() {
                return false;
            }
        }
    }
</script>

<style>

</style>
